export const GET_PRESSURE_GAUGES_LIST_IN_PROGRESS =
  "GET_PRESSURE_GAUGES_LIST_IN_PROGRESS";
export const GET_PRESSURE_GAUGES_LIST_SUCCESS =
  "GET_PRESSURE_GAUGES_LIST_SUCCESS";
export const GET_PRESSURE_GAUGES_LIST_FAIL = "GET_PRESSURE_GAUGES_LIST_FAIL";
export const GET_PRESSURE_GAUGE_INFOS_IN_PROGRESS =
  "GET_PRESSURE_GAUGE_INFOS_IN_PROGRESS";
export const GET_PRESSURE_GAUGE_INFOS_SUCCESS =
  "GET_PRESSURE_GAUGE_INFOS_SUCCESS";
export const GET_PRESSURE_GAUGE_INFOS_FAIL = "GET_PRESSURE_GAUGE_INFOS_FAIL";
export const POST_PRESSURE_GAUGE_IN_PROGRESS = "POST_PRESSURE_GAUGE_IN_PROGRESS";
export const POST_PRESSURE_GAUGE_SUCCESS = "POST_PRESSURE_GAUGE_SUCCESS";
export const POST_PRESSURE_GAUGE_FAIL = "POST_PRESSURE_GAUGE_FAIL";
export const PUT_PRESSURE_GAUGE_IN_PROGRESS = "PUT_PRESSURE_GAUGE_IN_PROGRESS";
export const PUT_PRESSURE_GAUGE_SUCCESS = "PUT_PRESSURE_GAUGE_SUCCESS";
export const PUT_PRESSURE_GAUGE_FAIL = "PUT_PRESSURE_GAUGE_FAIL";
export const DELETE_PRESSURE_GAUGE_IN_PROGRESS =
  "DELETE_PRESSURE_GAUGE_IN_PROGRESS";
export const DELETE_PRESSURE_GAUGE_SUCCESS = "DELETE_PRESSURE_GAUGE_SUCCESS";
export const DELETE_PRESSURE_GAUGE_FAIL = "DELETE_PRESSURE_GAUGE_FAIL";
